module.exports = __webpack_public_path__ + "static/media/account.8392cfb8.svg";